import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceOrganizations = /*#__PURE__*/function (_Service) {
  _inherits(ServiceOrganizations, _Service);

  var _super = _createSuper(ServiceOrganizations);

  function ServiceOrganizations() {
    var _this;

    _classCallCheck(this, ServiceOrganizations);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "fetchFollowups", function (params) {
      return _this.axiosInstance.get(ENDPOINTS.organizations.followups, {
        params: {
          organization_id: params === null || params === void 0 ? void 0 : params.organization_id,
          limit: params === null || params === void 0 ? void 0 : params.limit,
          offset: params === null || params === void 0 ? void 0 : params.offset
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createEmployerFollowup", function (params) {
      var csmResponsibleId = params.csmResponsibleId,
          followupContactMethod = params.followupContactMethod,
          followupStatus = params.followupStatus,
          notes = params.notes,
          referentContactId = params.referentContactId,
          organizationId = params.organizationId;
      return _this.axiosInstance.post(ENDPOINTS.organizations.followups, {
        csm_responsible_id: csmResponsibleId,
        organization_id: organizationId,
        referent_contact_id: referentContactId,
        followup_contact_method: followupContactMethod,
        followup_status: followupStatus,
        notes: notes
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateEmployerFollowup", function (id, params) {
      var csmResponsibleId = params.csmResponsibleId,
          organizationId = params.organizationId,
          followupContactMethod = params.followupContactMethod,
          followupStatus = params.followupStatus,
          notes = params.notes,
          referentContactId = params.referentContactId;
      return _this.axiosInstance.put("".concat(ENDPOINTS.organizations.followups, "/").concat(id), {
        csm_responsible_id: csmResponsibleId,
        organization_id: organizationId,
        referent_contact_id: referentContactId,
        followup_contact_method: followupContactMethod,
        followup_status: followupStatus,
        notes: notes
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchFollowup", function (id) {
      return _this.axiosInstance.get("".concat(ENDPOINTS.organizations.followups, "/").concat(id));
    });

    _defineProperty(_assertThisInitialized(_this), "deleteEmployerFollowup", function (id) {
      return _this.axiosInstance["delete"]("".concat(ENDPOINTS.organizations.followups, "/").concat(id));
    });

    _defineProperty(_assertThisInitialized(_this), "getMissedOrgApplicationActivities", function (params) {
      return _this.axiosInstance.get(ENDPOINTS.organizations.missedOrgApplicationActivities, {
        params: params
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFlexibleSlotPrices", function () {
      return _this.axiosInstance.get(ENDPOINTS.organizations.flexibleSlotPrices);
    });

    return _this;
  }

  _createClass(ServiceOrganizations, [{
    key: "indexOrganizations",
    value: function indexOrganizations(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          order_by = _ref.order_by,
          filters = _ref.filters;
      return this.axiosInstance.get(ENDPOINTS.organizations.root, {
        params: _objectSpread({
          limit: limit,
          offset: offset,
          order_by: order_by
        }, filters)
      });
    }
  }, {
    key: "createOrganization",
    value: function createOrganization(params) {
      return this.axiosInstance.post(ENDPOINTS.organizations.root, params);
    }
    /**
     * Public endpoint to look up a referral code and return the referrer info.
     * Used by /getting-started?ref=XXXX to display referrer restaurant name.
     */

  }, {
    key: "lookupReferralCode",
    value: function lookupReferralCode(referralCode) {
      return this.axiosInstance.get("".concat(ENDPOINTS.organizations.root, "/referral_lookup"), {
        params: {
          referral_code: referralCode
        }
      });
    }
    /**
     * Public endpoint to look up a B2B partner (ambassador) code and return the
     * partner name. Used by /getting-started?partner=XXXX to display the
     * "2 free days offered by X" intro screen. Only resolves codes of
     * ambassadors enrolled in the B2B procacciatore program.
     */

  }, {
    key: "lookupPartnerCode",
    value: function lookupPartnerCode(partnerCode) {
      return this.axiosInstance.get("".concat(ENDPOINTS.organizations.root, "/partner_lookup"), {
        params: {
          partner_code: partnerCode
        }
      });
    }
    /**
     * Authenticated endpoint to get referral bonus info for the logged-in user's organization.
     * Returns { referrer_restaurant_name } if the org was referred, or null.
     */

  }, {
    key: "getReferralBonusInfo",
    value: function getReferralBonusInfo() {
      return this.axiosInstance.get(ENDPOINTS.organizations.referralBonusInfo);
    }
  }, {
    key: "updateOrganization",
    value: function updateOrganization(data) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.organizations.root, "/").concat(data.id), data);
    }
  }, {
    key: "showOrganization",
    value: function showOrganization(organizationId, context) {
      return this.axiosInstance.get("".concat(ENDPOINTS.organizations.root, "/").concat(organizationId), {
        params: {
          context: context
        }
      });
    }
  }, {
    key: "fetchStripeSubscriptions",
    value: function fetchStripeSubscriptions(_ref2) {
      var companyId = _ref2.companyId,
          organizationId = _ref2.organizationId;
      return this.axiosInstance.get(ENDPOINTS.companies.subscriptions, {
        params: {
          company_id: companyId,
          organization_id: organizationId
        }
      });
    } // COMPANIES //

  }, {
    key: "listCompanies",
    value: function listCompanies(_ref3) {
      var organizationId = _ref3.organizationId,
          limit = _ref3.limit,
          offset = _ref3.offset,
          context = _ref3.context,
          filterDefault = _ref3.filterDefault;
      return this.axiosInstance.get(ENDPOINTS.companies.root, {
        params: {
          organization_id: organizationId,
          limit: limit,
          offset: offset,
          context: context,
          "default": filterDefault
        }
      });
    }
  }, {
    key: "createCompany",
    value: function createCompany(data) {
      return this.axiosInstance.post(ENDPOINTS.companies.root, data);
    }
  }, {
    key: "updateCompany",
    value: function updateCompany(data) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.companies.root, "/").concat(data.id), data);
    }
  }, {
    key: "deleteCompany",
    value: function deleteCompany(companyId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.companies.root, "/").concat(companyId));
    } // STRIPE //

  }, {
    key: "fetchStripeCustomerPortal",
    value: function fetchStripeCustomerPortal(_ref4) {
      var companyId = _ref4.companyId,
          organizationId = _ref4.organizationId;
      return this.axiosInstance.get(ENDPOINTS.companies.stripeCustomerPortal, {
        params: {
          company_id: companyId,
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "fetchStripePaymentMethods",
    value: function fetchStripePaymentMethods(_ref5) {
      var organizationId = _ref5.organizationId,
          companyId = _ref5.companyId;
      return this.axiosInstance.get(ENDPOINTS.organizations.paymentMethods, {
        params: {
          organization_id: organizationId,
          company_id: companyId
        }
      });
    }
  }, {
    key: "detachPaymentMethod",
    value: function detachPaymentMethod(_ref6) {
      var paymentMethodId = _ref6.paymentMethodId;
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.organizations.paymentMethods, "/").concat(paymentMethodId));
    }
  }, {
    key: "updateDefaultPaymentMethod",
    value: function updateDefaultPaymentMethod(_ref7) {
      var stripeCustomerId = _ref7.stripeCustomerId,
          paymentMethodId = _ref7.paymentMethodId;
      return this.axiosInstance.patch("".concat(ENDPOINTS.organizations.updateStripeCustomer, "/").concat(stripeCustomerId), {
        payment_method_id: paymentMethodId
      });
    }
  }, {
    key: "attachPaymentMethod",
    value: function attachPaymentMethod(_ref8) {
      var stripeCustomerId = _ref8.stripeCustomerId,
          paymentMethodId = _ref8.paymentMethodId,
          isDefault = _ref8.isDefault;
      return this.axiosInstance.post(ENDPOINTS.organizations.paymentMethods, {
        stripe_customer_id: stripeCustomerId,
        payment_method_id: paymentMethodId,
        is_default: isDefault
      });
    }
  }, {
    key: "createPaymentMethodSetupIntent",
    value: function createPaymentMethodSetupIntent(_ref9) {
      var companyId = _ref9.companyId;
      return this.axiosInstance.post(ENDPOINTS.organizations.paymentMethodSetupIntent, {
        company_id: companyId
      });
    }
  }, {
    key: "sendSubscriptionEmail",
    value: function sendSubscriptionEmail(_ref10) {
      var companyId = _ref10.companyId,
          paymentLink = _ref10.paymentLink;
      return this.axiosInstance.post(ENDPOINTS.companies.subscriptionEmail, {
        company_id: companyId,
        payment_link: paymentLink
      });
    } // FOLLOWUPS //

  }, {
    key: "createOrganizationStructuredNote",
    value: function createOrganizationStructuredNote(note) {
      return this.axiosInstance.post(ENDPOINTS.organizations.structuredNotes, note);
    }
  }, {
    key: "updateOrganizationStructuredNote",
    value: function updateOrganizationStructuredNote(note) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.organizations.structuredNotes, "/").concat(note.organization_id), note);
    }
  }, {
    key: "getDiscrepanciesBetweenSlotsAndActiveJobPositions",
    value: function getDiscrepanciesBetweenSlotsAndActiveJobPositions(_ref11) {
      var organizationId = _ref11.organizationId;
      return this.axiosInstance.get("".concat(ENDPOINTS.organizations.discrepancies), {
        params: {
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "getOrganizationsWithSlotAndJpDiscrepancies",
    value: function getOrganizationsWithSlotAndJpDiscrepancies(_ref12) {
      var csmId = _ref12.csmId,
          isAdmin = _ref12.isAdmin;
      return this.axiosInstance.get(ENDPOINTS.organizations.discrepancies, {
        params: {
          csm_id: csmId,
          is_admin: isAdmin
        }
      });
    }
  }, {
    key: "getOrganizationPerformanceMetrics",
    value: function getOrganizationPerformanceMetrics() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          organizationId = _ref13.organizationId;

      return this.axiosInstance.get(ENDPOINTS.organizations.performanceMetrics, {
        params: {
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "insertOrUpdateSnoozedOrganization",
    value: function insertOrUpdateSnoozedOrganization(params) {
      return this.axiosInstance.post(ENDPOINTS.organizations.snooze, params);
    }
  }, {
    key: "reactivateSnoozedOrganization",
    value: function reactivateSnoozedOrganization(organizationId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.organizations.snooze, "/").concat(organizationId));
    }
  }, {
    key: "checkInvoicesStatus",
    value: function checkInvoicesStatus(_ref14) {
      var organizationId = _ref14.organizationId;
      return this.axiosInstance.get(ENDPOINTS.organizations.checkInvoicesStatus, {
        params: {
          organization_id: organizationId
        }
      });
    } // ── Referral Requests ──────────────────────────────────────────────

    /**
     * Public endpoint: prospect submits a referral request to an employer.
     */

  }, {
    key: "createReferralRequest",
    value: function createReferralRequest(data) {
      return this.axiosInstance.post(ENDPOINTS.organizations.referralRequests, data);
    }
    /**
     * Public endpoint: check if a referral request already exists for this prospect + restaurant.
     */

  }, {
    key: "checkReferralRequestExistence",
    value: function checkReferralRequestExistence(data) {
      return this.axiosInstance.post(ENDPOINTS.organizations.checkReferralRequestExistence, data);
    }
    /**
     * Authenticated endpoint: list referral requests for the logged-in employer's organization.
     */

  }, {
    key: "listReferralRequests",
    value: function listReferralRequests(params) {
      return this.axiosInstance.get(ENDPOINTS.organizations.referralRequests, {
        params: {
          limit: params === null || params === void 0 ? void 0 : params.limit,
          status: params === null || params === void 0 ? void 0 : params.status
        }
      });
    }
    /**
     * Authenticated endpoint: update a pending referral request (accept or reject).
     */

  }, {
    key: "updateReferralRequest",
    value: function updateReferralRequest(id, data) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.organizations.referralRequests, "/").concat(id), data);
    }
  }, {
    key: "upsertProspect",
    value: function upsertProspect(params) {
      return this.axiosInstance.put(ENDPOINTS.organizations.prospects, params);
    }
  }]);

  return ServiceOrganizations;
}(Service);

export function useOrganizationsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceOrganizations(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export var createOrganizationService = function createOrganizationService(_ref15) {
  var baseUrl = _ref15.baseUrl,
      jwt = _ref15.jwt;
  return new ServiceOrganizations(dynamicAxios(baseUrl, jwt));
};
export default useOrganizationsService;